import React from 'react';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import HomePage from './Pages/HomePage';
import GamePage from './Pages/GamesPage';
import LoginPage from './Pages/LoginPage';
import SubscribePage from './Pages/SubscribePage';
import OtpPage from './Pages/OtpPage';
import ConfirmationPage from './Pages/ConfirmationPage';
import PrivacyPolicy from './Pages/PrivacyPolicy';

const App = () => {
  const router = createBrowserRouter([
    {

      path: "/",
      element: <HomePage />
    },
    {
      path: "/login",
      element: <LoginPage />
    },
    {
      path: "/subscribe",
      element: <SubscribePage />
    },
    {
      path: "/privacy-policy",
      element: <PrivacyPolicy />
    },
    {
      path: "/otp",
      element: <OtpPage />
    },
    {
      path: "/confirmation",
      element: <ConfirmationPage />
    },
    {
       path:"/games/:id/:name",
      element:<GamePage />
    },
    
    // {
    //   path: "*",
    //   element: <Navigate to="/" />
    // }
  ]);

  return (
    <RouterProvider router={router} />
    
  );
};

export default App;